import styled from '../references';

export interface Location {
  bottom?: string;
  left?: string;
  right?: string;
  top?: string;
}

export const FloatingDiv = styled.div<Location>`
  bottom: ${props => props.bottom ?? 'auto'};
  left: ${props => props.left ?? 'auto'};
  position: absolute;
  right: ${props => props.right ?? 'auto'};
  top: ${props => props.top ?? 'auto'};
  z-index: 20;
`;
